module.exports = __webpack_public_path__ + "static/media/11a-03_ST-2012-200x300cm-oleo-sobre-papel.b03878ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/11/11a-03_ST-2012-200x300cm-oleo-sobre-papel.jpg
// module id = 123
// module chunks = 0